"use client";

// ============================================================
// ANSICHTSSACHE-AGENT – Anmeldung: Fehler beim Laden einer Seite
// ============================================================
// Der Rahmen der Anmeldung ist leer (die Seiten zeichnen ihre
// Buehne selbst), deshalb bringt das Blatt seinen Grund mit.
// Gestalt in `components/fehlerblatt.tsx`.
// ============================================================

import { Fehlerblatt, type FehlerblattError } from "@/components/fehlerblatt";

export default function AuthError({
  error,
  reset,
}: {
  error: FehlerblattError;
  reset: () => void;
}) {
  return (
    <div className="bg-bg-secondary flex min-h-screen items-center justify-center px-6">
      <Fehlerblatt
        error={error}
        reset={reset}
        text="Die Seite konnte nicht geladen werden. Versuch es noch einmal."
        zurueck={{ href: "/login", label: "Zur Anmeldung" }}
      />
    </div>
  );
}
